/*------------------------------------------------------------------------------
 * Head Office Menu Mananger
 */
import _ from 'lodash';
import { PLATFORMS, isPayAtTablePlatform } from '@/legacy/api/app';

Mobi2Go.Menu = (function() {
    let ready = false;
    let menus;
    let categories;
    let products;
    let modifier_groups;
    let modifiers;
    let active_menu;
    const { default_menu_id } = Mobi2Go.headoffice;
    const default_menu_ids = Mobi2Go.headoffice.default_menus_ids;
    // Add event methods
    const events = Mobi2Go.app.mixinEvents('Menu');
    const { bind } = events;
    const { trigger } = events;
    const unbind = events.trigger;
    const { once } = events;
    const { Collection } = Mobi2Go._class.Common;

    let load_retries = 0;

    // Menu data may have been preloaded in the page by a separate mechanism
    let preload_timeout = null;
    function load() {
        if (window.__mobi2go_preload_menu !== undefined) {
            if (window.__mobi2go_preload_menu === null) {
                setTimeout(load, 20);

                // Fallback to default load strategy after 10 seconds
                if (preload_timeout === null) {
                    preload_timeout = setTimeout(function() {
                        delete window.__mobi2go_preload_menu;
                    }, 1000 * 10);
                }

                return;
            }
            loadData(window.__mobi2go_preload_menu);
            return;
        }

        syncFromServer();
    }

    load();

    function syncFromServer() {
        // Immediately load menu data from server
        Mobi2Go.app.serverRequest({
            endpoint: 'menu',
            api_version: 1,
            with_credentials: false,
            from_cdn: true,
            data: {
                cache_key: Mobi2Go.app.menu_cache_key,
                language: Mobi2Go.app.language,
            },
            success: loadData,
            error() {
                // Try again a few times
                if (load_retries < 10) {
                    load_retries++;
                    setTimeout(syncFromServer, 500);
                }
            },
        });
    }

    function onReady(callback) {
        if (ready && typeof callback === 'function') {
            callback();
        } else {
            once('ready', callback);
        }
    }

    function loadData(menu_data) {
        const { MenuItem } = Mobi2Go._class;
        // Create Menu:Item: objects
        menus = Collection(_.map(menu_data.menus, MenuItem.Menu));
        categories = Collection(_.map(menu_data.categories, MenuItem.Category));
        products = Collection(_.map(menu_data.products, MenuItem.Product));
        modifier_groups = Collection(
            _.map(menu_data.modifier_groups, MenuItem.ModifierGroup)
        );
        modifiers = Collection(_.map(menu_data.modifiers, MenuItem.Modifier));

        trigger('ready');
        ready = true;
    }

    function getMenusByTag(tag) {
            return (
                menus.filter(function(menu) {
                    return _.includes(menu.tags, tag);
                })
        );
    }

    function getDefaultMenu() {
        const first_default_menu = getDefaultMenus()[0];
        return first_default_menu;
    }

    function getDefaultMenus() {
        let default_menus = [menus.first()];

        if(isPayAtTablePlatform()) {
            const menus_by_tag = getMenusByTag(PLATFORMS.PAYATTABLE);
            default_menus = menus_by_tag ?? default_menus;
        } else {
            const menu_filtered = menus.filter(function(menu) {
                return _.includes(default_menu_ids, menu.id);
            })
            default_menus = menu_filtered ?? default_menus;
        }

        return default_menus;
    }

    return {
        getMenus() {
            return menus;
        },
        getCategories() {
            return categories;
        },
        getProducts() {
            return products;
        },
        getModifierGroups() {
            return modifier_groups;
        },
        getModifiers() {
            return modifiers;
        },
        getDefaultMenu,
        getDefaultMenus,
        getMenusByTag,
        getMenuMenus() {
            return menus.collection;
        },

        onReady,
        bind,
        trigger,
        unbind,
        once,

        syncFromServer,
    };
})();
